'use strict';
'use client';
import { j as e } from "../../external/react/jsx-runtime.js";
import { FontAwesomeIcon as f } from "../../external/@fortawesome/react-fontawesome/index.es.js";
import v from "./MessageView.js";
import C from "./MessageInputField.js";
import l from "../../external/classnames/index.js";
import { useTheme as T } from "../Provider/index.js";
import { faMessages as M, faUserDoctor as D, faCommentMedical as E, faBowlFood as F } from "../../external/@fortawesome/pro-solid-svg-icons/index.js";
import { useRef as R, useEffect as Y } from "react";
import A from "../Loading/index.js";
const I = "Your Medical Support Team", o = {
  nurse: "Your Medical Support Team",
  dietitian: "Your Dietitian Team"
}, q = "Support", i = {
  nurse: "Nurse",
  dietitian: "Dietitian"
}, G = D, n = {
  nurse: E,
  dietitian: F
}, H = "bg-grey-300 text-white", m = {
  nurse: {
    mosh: "text-green-light bg-[#6fab93]",
    moshy: "text-blue-extra-light bg-blue-light"
  },
  dietitian: {
    mosh: "bg-green-light text-[#6fab93]",
    moshy: "bg-blue-extra-light text-blue-light"
  }
}, Q = ["image/jpg", "image/jpeg", "image/png"], S = ({
  onSendMessage: u,
  onAttachImage: d,
  onOpenImage: h,
  onAttachFile: g,
  onOpenFile: p,
  showAttachImage: j = !0,
  showAttachFile: b = !0,
  hasMoreMessages: y,
  identity: w,
  ticket: s,
  isLoading: N
}) => {
  var x;
  const { isMosh: a, isMoshy: c } = T(), r = R(null), t = s == null ? void 0 : s.isClosed;
  return Y(() => {
    r.current && (r.current.scrollTop = r.current.scrollHeight);
  }, [s]), N ? /* @__PURE__ */ e.jsx("div", { className: "flex flex-col h-full w-full items-center justify-center bg-white text-grey-400", children: /* @__PURE__ */ e.jsx(A, {}) }) : s ? /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col justify-center w-full h-full relative bg-white min-h-0 flex-1", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "md:border-b border-grey-200 py-3 md:py-6 px-4 md:px-8 flex flex-row gap-3 items-start", children: [
      /* @__PURE__ */ e.jsx("div", { className: "flex items-center justify-center", children: /* @__PURE__ */ e.jsx(
        "div",
        {
          className: l(
            "flex items-center justify-center rounded-full p-2",
            t ? "bg-grey-300 text-white" : ((x = m == null ? void 0 : m[s.supportType]) == null ? void 0 : x[a ? "mosh" : "moshy"]) || H
          ),
          children: /* @__PURE__ */ e.jsx(
            f,
            {
              icon: (n == null ? void 0 : n[s.supportType]) || G,
              className: "!h-4 w-4"
            }
          )
        }
      ) }),
      /* @__PURE__ */ e.jsxs("div", { children: [
        /* @__PURE__ */ e.jsx(
          "h5",
          {
            className: l({
              "text-green-dark": a && !t,
              "text-black": c && !t,
              "text-grey-400": t
            }),
            children: (o == null ? void 0 : o[s.supportType]) || I
          }
        ),
        /* @__PURE__ */ e.jsxs("div", { className: "flex gap-1", children: [
          /* @__PURE__ */ e.jsx("span", { className: "p3 highlight text-grey-400", children: (i == null ? void 0 : i[s.supportType]) || q }),
          /* @__PURE__ */ e.jsx("span", { className: "text-grey-400 font-bolder leading-5", children: "•" }),
          /* @__PURE__ */ e.jsx(
            "span",
            {
              className: l("p3", {
                "text-green-faint-dark": a && !t,
                "text-blue": c && !t,
                "text-grey-400": t
              }),
              children: "Typically responds within 24 hours"
            }
          )
        ] })
      ] })
    ] }),
    /* @__PURE__ */ e.jsxs(
      "div",
      {
        className: l(
          "flex-1 shrink grow min-h-0 px-4 md:px-8 w-full h-full overflow-y-auto flex flex-col",
          {
            "pb-4": t
          }
        ),
        style: {
          scrollbarWidth: "thin",
          scrollbarColor: "[#e2e2e2] transparent",
          scrollbarGutter: "auto"
        },
        ref: r,
        children: [
          /* @__PURE__ */ e.jsx(
            v,
            {
              supportType: s.supportType,
              messages: s.messages,
              identity: w,
              hasMoreMessages: y,
              onOpenFile: p,
              onOpenImage: h,
              isClosed: t
            }
          ),
          /* @__PURE__ */ e.jsx("div", { ref: r })
        ]
      }
    ),
    t ? null : /* @__PURE__ */ e.jsx(
      C,
      {
        onSubmit: u,
        onAttachFile: g,
        onAttachImage: d,
        showAttachFile: b,
        showAttachImage: j,
        disabled: !1
      }
    )
  ] }) : /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col h-full w-full items-center justify-center bg-grey-100 text-grey-400", children: [
    /* @__PURE__ */ e.jsx(
      f,
      {
        icon: M,
        className: "!h-12 w-12 text-grey-300",
        color: ""
      }
    ),
    /* @__PURE__ */ e.jsx("h5", { className: "max-w-[380px] text-center", children: 'Choose a chat to open, or start a new support chat by selecting "Ask a question"' })
  ] });
};
export {
  n as chatThumbnailIconBySupportType,
  m as chatThumbnailStyleBySupportType,
  S as default,
  G as defaultChatThumbnailIcon,
  H as defaultChatThumbnailStyle,
  Q as imageContentTypes
};
